module.exports = __webpack_public_path__ + "static/media/FMB.d1571de7.png";